/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EditVisitPackageTemplateDto
 */
export interface EditVisitPackageTemplateDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditVisitPackageTemplateDto
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditVisitPackageTemplateDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof EditVisitPackageTemplateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditVisitPackageTemplateDto
     */
    'type': EditVisitPackageTemplateDtoTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EditVisitPackageTemplateDtoTypeEnum {
    Epilepsy = 'EPILEPSY',
    Consultation = 'CONSULTATION'
}


